import { render, staticRenderFns } from "./PasswordResetView.vue?vue&type=template&id=2281bde8&scoped=true"
import script from "./PasswordResetView.vue?vue&type=script&lang=js"
export * from "./PasswordResetView.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetView.vue?vue&type=style&index=0&id=2281bde8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2281bde8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2281bde8')) {
      api.createRecord('2281bde8', component.options)
    } else {
      api.reload('2281bde8', component.options)
    }
    module.hot.accept("./PasswordResetView.vue?vue&type=template&id=2281bde8&scoped=true", function () {
      api.rerender('2281bde8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/PasswordResetView.vue"
export default component.exports